var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import omit from 'lodash/omit';
import * as React from 'react';
import { SketchPicker } from 'react-color';
import InlineInput from '../inline-input/index';
import StyledPicker from './style';
var ColorPicker = /** @class */ (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function () {
            if (_this.props.disabled) {
                return;
            }
            _this.setState({ displayColorPicker: !_this.state.displayColorPicker, isFocused: true });
        };
        _this.handleClose = function () {
            _this.setState({ displayColorPicker: false, isFocused: false });
        };
        _this.handleChange = function (color) {
            _this.setState({ color: color.hex });
        };
        _this.onSaved = function (e, value) {
            _this.setState({ color: value });
            if (_this.props.onComplete) {
                _this.props.onComplete("" + value);
            }
        };
        _this.handleChangeComplete = function (color, event) {
            _this.setState({ color: color.hex });
            if (_this.props.onComplete) {
                _this.props.onComplete("" + color.hex);
            }
        };
        _this.onClickFocusInput = function (isFocused) {
            _this.setState({ isFocused: isFocused });
        };
        _this.state = {
            displayColorPicker: false,
            color: _this.props.color || '#000000',
            isFocused: false,
            colorFromProps: _this.props.color || '#000000',
        };
        return _this;
    }
    ColorPicker.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.color !== prevState.colorFromProps) {
            return {
                colorFromProps: nextProps.color,
                color: nextProps.color,
            };
        }
        return null;
    };
    ColorPicker.prototype.render = function () {
        var previewStyle = {
            background: "" + this.state.color,
        };
        var props = omit(this.props, 'onComplete');
        return (React.createElement(StyledPicker, __assign({}, props),
            React.createElement("div", { className: "swatch" }, this.props.inlineInput ? (React.createElement("div", { className: "color-inline " + (this.state.isFocused && 'focus'), onClick: this.handleClick },
                React.createElement("div", { className: 'preview' + (this.props.disabled ? ' disabled' : ''), style: previewStyle }),
                React.createElement("div", { className: "swatch-label" },
                    React.createElement(InlineInput, { disabled: this.props.disabled || this.props.disabledInlineInput || false, maxLength: 7, value: this.state.color, placeholder: "#000000", onSaved: this.onSaved, onClickFocusInput: this.onClickFocusInput })))) : (React.createElement("div", { className: 'color' + (this.props.disabled ? ' disabled' : ''), style: previewStyle, onClick: this.handleClick }))),
            this.state.displayColorPicker && this.props.disabled !== true ? (React.createElement("div", { className: "popover" },
                React.createElement("div", { className: "cover", onClick: this.handleClose }),
                React.createElement(SketchPicker, { color: this.state.color, onChange: this.handleChange, onChangeComplete: this.handleChangeComplete, disableAlpha: !!this.props.disableAlpha }))) : null));
    };
    return ColorPicker;
}(React.Component));
export default ColorPicker;
//# sourceMappingURL=index.js.map